
/* injects from baggage-loader */

/*
 * api SectionLesson service
 */

const moduleSectionLesson = angular.module('api.sectionLesson', []);

moduleSectionLesson.factory('SectionLesson', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope",
  ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) => {
    class SectionLessonApi {
      constructor() {
      }

      updateForMixer(section) {
        const {lessonId, pageId} = $state.params;
        const id = section.id + "";

        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).all("update_for_mixer").customPUT(section);
      }

      createPublic(params) {
        return Restangular.all("sections").post(params);
      }

      savePublic(section) {
        return Restangular.all("sections").one(section.id).customPUT(section);
      }

      createItem(section, params, isPublic = false) {
        if (isPublic) {
          return Restangular.all("sections").one(section.id).customPUT(params);
        } else {
          const {lessonId, pageId} = $state.params;
          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(params);
        }
      }

      destoyItem(section, imageId) {
        return Restangular.all("sections").one(section.id).all("images").one(imageId).customDELETE();
      }

      create(id, type) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").post({
          section_id: id,
          section_type: type
        });
      }

      clone(id, type) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections/clone").post({
          section_id: id,
          section_type: type
        });
      }

      save(layout) {
        const section = layout.section;

        this.setTextContents(layout);

        section.structure = this.generateJSON(layout.one(ns.wrapperClass));

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          const {lessonId, pageId} = $state.params;
          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(layout.section.id).customPUT(section);
        }
      }

      saveAllSectionsAndPublish(sections) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("batch_update").customPUT({sections: sections});
      }

      getBuildStatus() {
        const {lessonId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).one("build_status").get();
      }

      saveAllSectionsAndPublishPreview(sections) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("save_preview").customPUT({sections: sections});
      }

      saveSettings(section) {
        section = angular.copy(section);

        delete(section.structure);
        delete(section.background_attributes.images_attributes);

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          const {lessonId, pageId} = $state.params;
          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(section);
        }
      }

      remove(id) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).customPUT({removed: true});
      }

      removePublic(id) {
        return Restangular.all("sections").one(id).customDELETE()
      }

      restore(id) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(id).customPUT({removed: false});
      }

      removeBg(section) {
        section = angular.copy(section);
        section.remove_background = true;

        if (section.is_template) {
          return Restangular.all("sections").one(section.id).customPUT(section);
        } else {
          const {lessonId, pageId} = $state.params;
          return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id).customPUT(section);
        }
      }

      sort(sectionsIds) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").all("sort").post({sections: sectionsIds});
      }

      get(id) {
        return Restangular.all("lms_pages").one(id).get();
      }

      getHTML(section) {
        const {lessonId, pageId} = $state.params;
        return Restangular.all("lms_pages").one(lessonId).all("pages").one(pageId).all("sections").one(section.id + ".html").get();
      }

      getPublicSectionHTML(id) {
        return Restangular.all("sections").one(id + ".html").get();
      }

      getPublicSectionStylesheet() {
        const id = $state.params.sectionId;
        return Restangular.all("sections").one(id + ".css").get();
      }

      getCollection(category, colors) {
        return Restangular.one("sections").get({tag: category, for_lms_page: true, "color[]": colors});
      }

      /**
       * Запрос категорий
       * @param lms_page_id
       * @returns {*}
       */
      getCategories(lms_page_id) {
        return Restangular.all("sections").all("tags").getList({lms_page_id});
      }

      getSections() {
        return Restangular.all("sections").one("all").get();
      }

      getStylesheetsOfForm(id) {
        return Restangular.all("lms_pages").one(id).one("source.css").get();
      }

      /**
       * todo: Бесполезный метод, удалить, когда не будет использоваться
       * [Вызывается из layoutEditor]
       * @param layout
       * @returns {*}
       */
      beforeSave(layout) {
        return this.setTextContents(layout);
      }

      setTextContents(layout) {
        layout.all(
          [ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')
        ).each((block) => {
          // Very strange behaviour, sometimes the widget has property with empty name, and it produces an error while saving a page
          Object.keys(block.widget).forEach((k) => k === '' && delete block.widget[k]);

          if (!block.widget) {
            return block.widget.content = '';
          } else {
            return block.widget.content = block.one(ns.widgetWrapperClass).getHTML();
          }
        })
      }

      generateJSON(block) {
        const blocksBuilder = $injector.get("blocksBuilder");
        const result = {};

        if (!block) {
          err("Can't recognize block");
        }

        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each((block) => {
            result.cols.push(this.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {

          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }

          let widgets = [];
          let rows = [];

          block.get("children").each((block) => {
            if (block.test(ns.rowClass)) {
              if (0 !== widgets.length) {
                rows.push({
                  cols: [{
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }]
                });
                widgets = [];
              }

              rows.push(this.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              widgets.push(block);
            }
          });

          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            if (0 !== widgets.length && !result.size) {
              err("Col size is invalid: ", result.size);
            }
            if (result.size && widgets.length) {
              rows.push({
                cols: [{
                  size: result.size,
                  widgets: $rootScope.Y.clone(widgets, true)
                }]
              });
            }
            result.rows = rows;
          }
        }

        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete(result.rows);
          delete(result.cols);
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each((block) => {
            return result.widgets.push(block.widget);
          });
        }

        return result;
      }
    }

    return new SectionLessonApi();
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/api/sectionLesson.js